import { CandidateStatus, useGetCandidateProfessional } from '~/domain/PermanentJobs';
import { useAppSelector } from '~/hooks';
import { RejectProfessional } from './RejectProfessional';
import { ShortlistProfessional } from './ShortlistProfessional';
import './Styles.scss';

interface IProfessionalActions {
  isGoodRating: boolean;
}

export const ProfessionalActions = ({ isGoodRating }: IProfessionalActions) => {
  const currentJob = useAppSelector((state) => state.job.job);

  const { data, isInitialLoading } = useGetCandidateProfessional({
    postingId: currentJob?.postingId,
    professionalId: currentJob?.offer_final_reciever?.id,
  });

  if (!data || isInitialLoading) {
    return null;
  }

  return (
    <>
      {isGoodRating ? (
        <ShortlistProfessional
          isShortlisted={data.isShortlisted}
          professional={{
            firstName: currentJob?.offer_final_reciever?.first_name,
            id: data?.id,
          }}
        />
      ) : (
        <RejectProfessional
          isRejected={data.officeStatus === CandidateStatus.Rejected}
          professional={{
            firstName: currentJob?.offer_final_reciever?.first_name,
            fullName: currentJob?.offer_final_reciever?.full_name,
            id: data.id,
          }}
        />
      )}
    </>
  );
};
